export const environment = {
  production: false,
  serverUrl: "https://dev-frontend.colorjob.terenbro.com/backend",
  csrfEnabled: true
}

export const webSocketUrl = environment.serverUrl + '/ws';
export const apiUrl = environment.serverUrl + "/api"
